export { default, default as LinkWithIcon } from './LinkWithIcon'
export { default as linkWithIconTheme } from './themes/LinkWithIcon.theme'
export * as LinkWithIconStyles from './styles/LinkWithIcon.style'

export type { LinkWithIconProps } from './LinkWithIcon.types'
export type { AppearanceKeys, LinkWithIconTheme } from './themes/LinkWithIcon.theme.types'
export type { StyledLinkWithIconProps } from './styles/LinkWithIcon.style.types'
